<template>
<div id="about">
  <div class="sectionIntro">
    <div class="sectionBack"></div>
    <div class="sectionContent">
      <div class="introCover">
        <img src="@/../static/image/content/aboutPagePic.png" />
      </div>
      <div class="introContent">
        <span class="title">{{$t('avatamsaka.menu.aboutContrast')}}</span>
      </div>
    </div>
  </div>

  <div class="itemsBlocks funcArea">
    <h2>{{$t('avatamsaka.about.areaTitle01')}}</h2>
  </div>

  <div class="itemsBlocks">

    <div class="teamBlock">
      <div class="content">
        <p>
          <span class="itemTitle">{{$t('avatamsaka.about.area01')}}</span>
          <br/><span v-html="$t('avatamsaka.about.area01content')">
          </span>
        </p>
      </div>
      <div class="imgContent">
        <img src="@/../static/image/content/about1.jpg" />
      </div>
    </div>
  </div>

  <div class="itemsBlocks">

    <div class="teamBlock">
      <div class="imgContent">
        <img src="@/../static/image/content/about2.jpg" />
      </div>
      <div class="content">
        <p>
          <span class="itemTitle">{{$t('avatamsaka.about.area02')}}</span>
          <br/><span v-html="$t('avatamsaka.about.area02content')">
          </span>
        </p>
      </div>
    </div>
  </div>

  <div class="itemsBlocks">

    <div class="teamBlock">
      <div class="content">
        <p>
          <span class="itemTitle">{{$t('avatamsaka.about.area03')}}</span>
          <br/><span v-html="$t('avatamsaka.about.area03content')">
          </span>
        </p>
      </div>
      <div class="imgContent">
        <img src="@/../static/image/content/about3.jpg" />
      </div>
    </div>
  </div>

  <div class="itemsBlocks">

    <div class="teamBlock">
      <div class="imgContent">
        <img src="@/../static/image/content/about4.jpg" />
      </div>
      <div class="content">
        <p>
          <span class="itemTitle">{{$t('avatamsaka.about.area04')}}</span>
          <br/><span v-html="$t('avatamsaka.about.area04content')">
          </span>
        </p>
      </div>
    </div>
  </div>

  <div class="itemsBlocks">

    <div class="teamBlock">
      <div class="content">
        <p>
          <span class="itemTitle">{{$t('avatamsaka.about.area05')}}</span>
          <br/><span v-html="$t('avatamsaka.about.area05content')">
          </span>
        </p>
      </div>
      <div class="imgContent">
        <img src="@/../static/image/content/about5.jpg" />
      </div>
    </div>
  </div>


</div>
</template>

<script>

export default {
  name: 'about',
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>

#about {

  text-align: center;

  .mapBlocks {

    position: relative;
    display: flex;

    iframe {
      flex: 1;
      margin: 100px;
      margin-top: 20px;
      position: sticky;
      height: 550px;
      border: 15px solid rgba(102, 62, 23, 0.17);
    }

    .content {
      flex: 2;
      align-self: center;
    }

    .sectionBack {
      bottom: 0px;
      width: 100%;
      height: 20%;
      min-height: 20px;
      background: #d9e2c4;
      position: absolute;
    }
    .sectionBack::after {
      border-bottom: 20vh solid #d9e2c4;
      border-left: 50vw solid transparent;
      content: "";
      bottom: 100%;
      right: 0;
      position: absolute;
    }

  }

  .sectionIntro {
      display: flex;
      padding-bottom: 50px;
      position: relative;

    .sectionBack {
      margin-bottom: 40px;
      width: 100%;
      background: #d9e2c4;
      position: absolute;
    }

    .sectionBack::after {
        border-top: 50vh solid #d9e2c4;
        border-right: 100vw solid transparent;
        content: "";
        top: 100%;
        left: 0;
        position: absolute;
    }

    .sectionContent{
      display: flex;
      position: relative;
      width: 100%;
      .introCover {
        position: sticky;
        flex: 1;
        padding: 0px;
        margin: 20px;
        img {
          max-width: 300px;
          width: 100%;
          float: right;
          margin: 60px 40px;
        }
      }
      .introContent {
        align-self: center;
        text-align: left;
        .title {
          padding: 20px;
          padding-left: 0px;
          font-size: 2.2em;
          text-shadow: 0px 0px 10px #fff, 0px 0px 10px #fff,
          0px 0px 10px #fff, 0px 0px 10px #fff, 0px 0px 10px #fff,
          0px 0px 10px #fff, 0px 0px 10px #fff;
        }
        position: sticky;
        flex: 1;
        margin: 60px 0px;
        padding: 20px;
        align-self: left;
      }
    }


    @media (max-width: 768px) {

        display: block;
        flex-direction: row;

        .mapBlocks .sectionBack::after {
          border: none;
        }

        .introCover, .introContent {
          clear: both;
          display: block;
          width: 100%;
          flex: none;
          margin: 0px;
          padding: 40px;
        }

        .introCover {
          position: relative;
          margin: 0;
          img {
            width: 100%;
          }
        }
    }
  }


  .itemsBlocks{
    margin: 0px;
    position: relative;
    h2 {
      position: sticky;
      margin: 0.8em auto;
      padding-left: 100px;
      padding-right: 100px;
    }
    .itemBlock {
      position: sticky;
      padding-left: 100px;
      padding-right: 100px;
      padding-bottom: 100px;
      height: 100%;
      overflow: hidden;
      img {
        max-width: 600px;
        max-height: 100%;
        padding-right: 40px;
        overflow: hidden;
        position: relative;
        float: left;
        clear: left;
      }
    }

    .teamBlock {
      display: flex;
      flex-direction: row;
      margin-bottom: 150px;

        justify-content: center;
        align-items: center;

      .content {
        flex: 1;
        background: rgba(#d9e2c3, 0.43);
        align-self: center;
        padding:2em;
        padding-top: 50px;
        padding-bottom: 50px;
        text-align: left;
        .itemTitle {
          font-size: 2rem;
        }
      }
      .imgContent {
        flex: 1;

        img {
          max-width: 100%;
          border: 16px solid rgba(212, 211, 211, 0.1);
          padding: 3px;
        }
      }
    }

    .sectionBack {
      bottom: 0px;
      width: 100%;
      height: 20%;
      min-height: 20px;
      background: #d9e2c4;
      position: absolute;
    }
    .sectionBack::after {
      border-bottom: 20vh solid #d9e2c4;
      border-left: 50vw solid transparent;
      content: "";
      bottom: 100%;
      right: 0;
      position: absolute;
    }
  }

  .funcArea {
    text-align: left;
    h2 {
      text-align: center;
      font-size: 1.7em;
      margin-bottom: 3em;
    }
    p {
      line-height: 1.6em;
    }
  }

  @media (max-width: 768px) {

    .sectionIntro {
      .sectionContent {
        .introCover {
          img {
            margin: 0px;
            margin-top: calc(80px - 1em);
          }
        }
        .introContent {

          .title {
            font-size: 1.5em;
          }
        }
      }
    }

      .itemsBlocks {

        padding: 1em;
        text-align: left;

        h2 {
          padding: 0px;
          margin: 0px;
          text-align: center;
        }

        .itemBlock {
          padding: 0px;
        }

        .teamBlock {
          margin: 0px;
          position: relative;
          height: 100%;
          flex-direction: column;
          .imgContent {
            width: 100%;
            border-bottom: 1em solid white;
            img {
              width: 100%;
            }
          }
          .content {
            display: block;
            padding: 1em 2em;
          }
        }

    }

    .mapBlocks {
      display: initial;
      background: yellow;
      p {
        margin-top: -1em;
      }
      iframe {
        width: 80%;
        height: 80%;
        display: block;
        margin: 0 auto;
        border: none;
        border-bottom: 4em solid transparent;
      }
      .content {
        width: 100%;
        display: block;
        padding: 1em;
        padding-bottom: 2em;
      }
    }
  }
  @media (max-width: 768px) {
    .itemsBlocks {
      .teamBlock {
        .content {
          width: 100%;
        }
        .imgContent {
          img {
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue